import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Windows = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m3.094 18.809 7.262 1.052v-6.949H3.094zm0-6.89h7.262V4.972L3.094 6.023zm8.255 8.086 9.744 1.411v-8.503H11.35zm0-15.178v7.093h9.744V3.416z'
        fill='currentColor'
      />
    ) : (
      <path
        d='m3.094 18.809 7.262 1.052v-6.949H3.094zm0-6.89h7.262V4.972L3.094 6.023zm8.255 8.086 9.744 1.411v-8.503H11.35zm0-15.178v7.093h9.744V3.416z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
